export default __webpack_public_path__ + "static/media/steampad_doc.56175f46.pdf";